export function generateCertificate(elem) {

    if (!elem) return

    const API_ENDPOINT = '/umbraco/api/PdfGenerator/Generate'
    let form = elem.querySelector('form');
    let button = form.querySelector('.js-submit-certificate');
    let firstname = form.querySelector('[data-js-firstname]');
    let lastname = form.querySelector('[data-js-lastname]');

    const loadingSpinner = document.getElementById("loading");

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        generate();
    });

    button.addEventListener('click', () => {
        e.preventDefault();
        generate();
    });

    function generate() {
        if (firstname.value === '' && lastname.value === '') {
            return;
        }

        loadingSpinner.style.display = "block";
        elem.classList.add('dimmed');



        fetch(API_ENDPOINT, {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({ firstname: firstname.value, lastname: lastname.value })
        })
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.text();
            })
            .then((data) => {
                window.location.href = data;
                // window.open(data, "_blank");
                loadingSpinner.style.display = "none";
                elem.classList.remove('dimmed');
            })
            .catch((error) => {
                loadingSpinner.style.display = "none";
                console.error("Failed to generate the certificate:", error);
                elem.classList.remove('dimmed');
            })
    }
}
